import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { OWNER_PAYOUTS_QUERY_KEY } from "./constants";
import { buildOwnerPayoutsQuery, type OwnerPayoutsFilters } from "./owner-payouts-query";
import type { OwnerPayoutsResponse } from "./types";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. `GET /api/admin/venue-owners/
 * :userId/payouts` (API-FIN-8) is the admin mirror of the owner-facing history,
 * keyed by the owner's user id. Read tier: WANDERFIT_ADMIN + WANDERFIT_FINANCE.
 * A non-existent owner returns `200` with `payouts: []` (never 404).
 */
export function useOwnerPayouts(userId: string, filters: OwnerPayoutsFilters) {
  return useQuery({
    queryKey: [...OWNER_PAYOUTS_QUERY_KEY, userId, filters.status ?? "all", filters.limit] as const,
    queryFn: () =>
      httpClient<OwnerPayoutsResponse>(
        `/api/admin/venue-owners/${encodeURIComponent(userId)}/payouts${buildOwnerPayoutsQuery(filters)}`,
      ),
    enabled: userId.length > 0,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
